export default ({
    name : 'ProductBasic'
    , data () {
        return {
            productList : []
            , adminProductList : []
            , orderByClassName      : ''
            , orderBySelectedName   : '최신순'
            , orderBySelectedValue  : 'RECENT'
            , page : 1
            , limit : 5 
            , limitAdmin : 5 
            , isNext : false
            , hashTagConfig : {}
            , prdEmptyImage : '//image.makeshop.co.kr/mysoho/assets/shop/img/common/bul_empty.png'
        }
    }
    , created () {
        this.code = 'product_basic';
        this.basic = this.getDetailDataByCode(this.code);
        this.orderBySelectedValue = this.basic.data.order_by.value;
        this.orderBySelectedName = this.getOrderByName(this.basic.data.order_by.value);
        return {}
    }
    , mounted () {
        var listBack = sessionStorage.getItem('listBack');
        if (listBack !== 'N' || this.getAdminEditMode()) {
            this.getProductList();
        } else {
            sessionStorage.setItem('listBack', 'N');
            if (typeof this.basic.data.default_list !== 'undefined') {
                this.setProductList(this.basic.data.default_list);
            }
        }
        if (this.getAdminEditMode()) {
            this.settingOnContentShow()
        }
    }
    , computed : {
        isShowType1 () {
            return this.getShowTypeValue() == this.getShowTypeEnumValue(0)
        }
        , isShowType2 () {
            return this.getShowTypeValue() == this.getShowTypeEnumValue(1)
        }
        , isShowType3 () {
            return this.getShowTypeValue() == this.getShowTypeEnumValue(2)
        }
        , isShowType4 () {
            return this.getShowTypeValue() == this.getShowTypeEnumValue(3)
        }
        , getHashTagConfig () {
            if (this.isChangedSearchHashTag() === true) {
                this.page = 1
                this.getProductList()
            }
            return this.hashTagConfig
        }
        , getDisplayProductList () {
            if (this.getAdminEditMode()) {
                return this.getDisplayAdminProductList()
            }
            return this.productList
        }
        , rows () {
            let def  = (isNaN(parseInt(this.basic.data.rows.default))) ? 4 : parseInt(this.basic.data.rows.default)
            let rows = (isNaN(parseInt(this.basic.data.rows.value))) ? def : parseInt(this.basic.data.rows.value)
            return rows
        }
        , column () {
            let def     = (isNaN(parseInt(this.basic.data.column.default))) ? 1 : parseInt(this.basic.data.column.default)
            let column  = (isNaN(parseInt(this.basic.data.column.value))) ? def : parseInt(this.basic.data.column.value)
            return column
        }
        , changeRowsEng () {
            switch (this.rows) {
                case 2: return 'two'
                case 3: return 'three'
                case 4: return 'four'
                case 5: return 'five'
            }
            return 'four'
        }
    }
    , methods : {
        getOrderByEnums () {
            return this.basic.data.order_by.enums;
            //return this.orderByEnums
        }
        , getOrderByName (order) {
            if (order == 'RECENT'   ) { return '최신순'; }
            if (order == 'SELL_CNT' ) { return '판매순'; }
            if (order == 'LOW_PRICE') { return '낮은가격순'; }
			if (order == 'HIGH_REVIEW') { return '리뷰많은순'; }
			if (order == 'HIGH_GRADE') { return '평점높은순'; }
        }
		, getOrderByNameList (order) {            
			if (this.basic.data.order_by.value) { return view_item_list(order,this.productList) }
			return '';
        }
        , getOrerByClass (order) {
            if (this.basic.data.order_by.value == order) { return 'on'; }
            return '';
        }
        , getShowTypeValue () {
            return this.basic.data.show_type.value;
        }
        , getShowTypeEnumValue (key) {
            return this.basic.data.show_type.enums[key];
        }
        , getLimit () {
            return this.rows * this.column
        }
        , getProductList () {
            if (this.getAdminEditMode() && this.page != 1) return
            let isBack = sessionStorage.getItem('listBack');
            let params = new FormData()
            params.append('page', this.page)
            params.append('limit', this.getAdminEditMode() ? this.limitAdmin : this.getLimit())
            params.append('is_all', (isBack === 'Y') ? true : false)
            params.append('tag', this.getProductSearchHashTag())
            params.append('orderBy', this.orderBySelectedValue)
                
            // sessionStorage 에 있다면 실행안함.
            //if (sessionStorage.getItem('productList')) {
                //return
            //}

			this.$http.post(`${this.baseURI}${this.displayDataUrl['product']}`, params, { headers : this.axiosCommonHeader }
            ).then(response => {
                if (typeof response.data == 'undefined') {
                    return
                }
                this.setProductList(response.data)
                if (this.isChangedSearchHashTag() === true) {
                    vm.$store.commit('initProductSearchHashTag', {});
                }
            }).catch(error => {
            })
        }
        , getPayUrl (productId, stockType) {
            if (this.getAdminEditMode()) {
                return 'javascript:void(0);'
            }
            return 'javascript:check_cart(' + productId + ');'
        }
        , goPayUrl (productId, stockType) {
            if (this.getAdminEditMode()) {
                return false
            }
            return check_cart(productId)
        }
        , getPayClass (stockType) {
            if (this.isSoldOutStockType(stockType)) {
                return 'btn-soldout'
            }
            return (viewCart) ? 'btn-buy' : 'btn-buy-100'
        }
		, getCartUrl (stockType) {
            if (this.isSoldOutStockType(stockType)) {
                return 'MSH-display-none'
            }
            return (viewCart) ? 'MSH-btn-cart-add' : 'MSH-display-none'
        }
        , getSoldoutClassName (stockType) {
            if (this.isSoldOutStockType(stockType)) return 'soldout'
            return ''
        }
        , isSoldOutStockType (stockType) {
            if (stockType == 'soldout') return true
            return false
        }
        , setProductList (data) {
            this.isNext = (data.is_next === true) ? true : false;
            if (this.page == 1) {
                this.productList = data.list
                this.adminProductList = data.list 
                if (typeof data.phtConfig == 'object' && typeof data.phtConfig.input == 'object') {
                    this.hashTagConfig = data.phtConfig
                }
            } else {
                this.productList = this.productList.concat(data.list)
            }
            // adminEditMode scroll use
            if (this.getAdminEditMode()) {
            } else {
                this.page += 1
                sessionStorage.setItem('listBack', 'N');
            }
            this.$nextTick(() => {
                this.controlContentBorder();
            });
        }
        , setOrderByClass (order) {
            this.orderBySelectedName = this.getOrderByName(order);
            this.orderBySelectedValue = order;
            this.page = 1;
            this.getProductList();
			this.getOrderByNameList(order);
        }
        , getDisplayAdminProductList () {
            let limit = this.rows
            let newList = []
            if (this.adminProductList.length < limit) return this.adminProductList
            for (let i=0; i<limit; i++) {
                newList[i] = this.adminProductList[i]
            }
            return newList
        }
        , updateList () {
            if (this.getAdminEditMode() && this.orderBySelectedName != this.basic.data.order_by.value) {
                this.orderBySelectedValue = this.basic.data.order_by.value
                this.orderBySelectedName = this.getOrderByName(this.basic.data.order_by.value)
            }
        }
        , showContent (index) {
            document.querySelectorAll('.pcver-prd-list-wrap div.cntInner')[index].style.display = 'block';
        }
        , hideContent (index) {
            document.querySelectorAll('.pcver-prd-list-wrap div.cntInner')[index].style.display = 'none';
        }
        , settingOnContentShow () {
            let _code = this.code
            $m(document).on('mouseover', '#settingArea-'+_code, function() {
                let _el = $m('#settingArea-'+_code)
                if (_el.parent().find('.imgInner').length > 0) {
                    _el.parent().find('.cntInner').show()
                }
            })
            $m(document).on('mouseleave', '#settingArea-'+_code, function() {
                let _el = $m('#settingArea-'+_code)
                if (_el.parent().find('.imgInner').length > 0) {
                    _el.parent().find('.cntInner').hide()
                }
            })
        }
    }
    , updated () {
        this.updateList();
    }
})
